// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_adb392f1","isPdpNotListed":"_ccb1710a","title":"_1a03bf62","artTitle":"_92a05225"};